/**
 * Published foundation-client testimonials (5★ + approved only).
 * Renders nothing when there are no published reviews, so it never shows empty.
 */
import React, { useEffect, useState } from 'react';
import { Star } from 'lucide-react';
import { API_URL } from '@/config/apiConfig';

export const PublishedTestimonials = () => {
  const [reviews, setReviews] = useState([]);

  useEffect(() => {
    (async () => {
      try {
        const r = await fetch(`${API_URL}/api/foundation-reviews/published?limit=6`);
        if (r.ok) { const d = await r.json(); setReviews(d.reviews || []); }
      } catch { /* silent — section just hides */ }
    })();
  }, []);

  if (!reviews.length) return null;

  return (
    <section className="py-20 px-4 bg-slate-50" data-testid="published-testimonials">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-1 mb-3">
            {[1, 2, 3, 4, 5].map((s) => <Star key={s} className="w-5 h-5 fill-amber-400 text-amber-400" />)}
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900">Loved by our foundation clients</h2>
          <p className="text-slate-500 mt-2">Real words from real Australian businesses using Corvana.</p>
        </div>
        <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
          {reviews.map((r) => (
            <figure key={r.review_id} className="bg-white rounded-2xl border border-slate-100 shadow-sm p-6 flex flex-col"
              data-testid={`testimonial-${r.review_id}`}>
              <div className="flex gap-0.5 mb-3">
                {[1, 2, 3, 4, 5].map((s) => <Star key={s} className="w-4 h-4 fill-amber-400 text-amber-400" />)}
              </div>
              <blockquote className="text-slate-700 text-[15px] leading-relaxed flex-1">“{r.testimonial}”</blockquote>
              <figcaption className="mt-4 pt-4 border-t border-slate-100">
                <div className="font-semibold text-slate-900">{r.client_name}</div>
                <div className="text-sm text-slate-500">{r.role ? `${r.role}, ` : ''}{r.company}</div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PublishedTestimonials;
